import { fetchAuthSession } from 'aws-amplify/auth';
import { get } from 'aws-amplify/api';
import { useQuery } from 'react-query';

export const FACTS_SHEET_QUERY_KEY = 'factsSheetQuery';

export const useFactsSheetsQuery = (patientUserId) => {
  return useQuery({
    queryKey: [FACTS_SHEET_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: getAllFactsSheets.bind(this, patientUserId),
    staleTime: Infinity,
    placeholderData: [],
    enabled: !!patientUserId,
  });
};

export const useFactSheetQuery = (id,patientUserId) => {
  return useQuery({
    queryKey: [FACTS_SHEET_QUERY_KEY,patientUserId],
    retry: false,
    queryFn:  getAllFactsSheets.bind(this, patientUserId),
    staleTime: Infinity,
    placeholderData: [],
    enabled: !!patientUserId,
    select: (factsSheet) => factsSheet.filter((a) => a.id === id)[0],
  });
};

const getAllFactsSheets = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: 'factssheetapi',
    path: '/facts-sheet/' + patientUserId,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};
